// Toggle the mobile menu open and closed
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');

    if (!burgerButton) {
        return;
    }

    // The trigger is a <button>, so Enter/Space already fire click; all this
    // has to do is keep the expanded state in sync for assistive tech.
    burgerButton.addEventListener('click', function () {
        const open = document.body.classList.toggle('gh-head-open');
        burgerButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
}
